import React, { useState, useEffect } from "react";
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import "../Css/Profile.css";
// import Navbar from "../Navbar";

const ProfileEdit = () => {
  const navigate = useNavigate();
  // const [uploadedImagePath, setUploadedImagePath] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [image, setImage] = useState("");
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [id, setId] = useState(0);
  const [fadeIn, setFadeIn] = useState(false);
  const [loading, setLoading] = useState(false); // Added loading state
  const [fetchError, setFetchError] = useState(null); // Added fetch error state

  // Profile Information States
  // const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [dob, setDoB] = useState("");
  const [gender, setGender] = useState("");
  // const [mentorName, setMentorName] = useState("");
  // const [mentorOptions, setMentorOptions] = useState([]);

  // Contact Information States
  const [email, setEmail] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [socialLink, setSocialLink] = useState("");
  const [address, setAddress] = useState("");

  // About User
  const [bio, setBio] = useState("");

  // About College
  const [collegeName, setCollegeName] = useState("");
  const [department, setDepartment] = useState("");
  const [year, setYear] = useState("");
  const [skills, setSkills] = useState("");

  useEffect(() => {
    setFadeIn(true);
    setLoading(true); // Start loading

    const storedEmail = Cookies.get('email');
    const storedUsername = Cookies.get('username');
    // fetchMentorList();

    if (storedEmail && storedUsername) {
      console.log("Stored Email:", storedEmail);
      console.log("Stored Username:", storedUsername);
      setEmail(storedEmail);
      // setUsername(storedUsername);
      fetchUserProfile(storedEmail);
    }
    else {
      Swal.fire({
        icon: 'warning',
        title: 'Authentication Error',
        text: 'No user data found. Please log in again.',
      }).then(() => {
        window.location.href = "/Login"; // Redirect to login page after alert
      });
      setLoading(false); // Stop loading if no user data
    }
  }, []);

  const fetchUserProfile = async (userEmail) => {
    try {
      const response = await fetch(`https://ethiccraft.org/backend/profile/read_byEmail.php?email=${userEmail}`, {
        credentials: 'include'
      });
      if (!response.ok) {
        console.error("Error fetching profile by read_by_email:", response.statusText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data && !data.error) {
        setId(data.id);
        // setUsername(data.username || "");
        setFullName(data.full_name || "");
        setBloodGroup(data.blood_group || "");
        setDoB(data.dob || "");
        setGender(data.gender || "");
        setWhatsapp(data.phone_number || "");
        setSocialLink(data.social_links || "");
        setAddress(data.address || "");
        setBio(data.bio || "");
        setCollegeName(data.college || "");
        setDepartment(data.department || "");
        setYear(data.year_of_study || "");
        setSkills(data.skills || "");
        // setMentorName(data.Mentors_Name || "");
        setImage(data.profile_image ? `https://ethiccraft.org/${data.profile_image}` : "");
      } else if (data && data.error) {
        console.error("Error fetching profile:", data.error);
        Swal.fire({
          icon: 'error',
          title: 'Error Fetching Profile',
          text: data.error,
        });
        setFetchError(data.error);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      Swal.fire({
        icon: 'error',
        title: 'Pls Log in again',
        text: `Failed to fetch profile data: ${error.message}`,
      });
      setFetchError(error.message);
    } finally {
      setLoading(false); // Stop loading regardless of success/failure
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData2 = new FormData();
    formData2.append("profile_image", file);
    formData2.append("id", id);

    try {
      setLoading(true);
      const response = await fetch("https://ethiccraft.org/backend/profile/update_images.php", {
        method: "POST",
        body: formData2,
        credentials: 'include'
      });

      const text = await response.text();

      if (response.ok && text) {
        fetchUserProfile(email); // Refresh profile data after upload
        Swal.fire({
          icon: "success",
          title: "Updated Successfully",
          text: "Profile Pic Updated Successfully.",
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: text.error || "Failed to upload image.",
        });
      }
    } catch (error) {
      console.error("Upload Error:", error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Error',
        text: error.message || "Unexpected error occurred while uploading image.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async () => {
    if (!newPassword || newPassword.length < 6) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Password',
        text: 'Password must be at least 6 characters long.',
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("new_password", newPassword);

      const response = await fetch("https://ethiccraft.org/backend/forget_password/change_password.php", {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      const resultText = await response.text();
      let json;
      try {
        json = JSON.parse(resultText);
      } catch (e) {
        throw new Error(`Invalid response: ${resultText}`);
      }

      if (response.ok) {
        setPasswordChanged(true);
        setNewPassword("");
        Swal.fire({
          icon: "success",
          title: "Password Updated",
          text: "Your password has been updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error Changing Password",
          text: "Failed to update password",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };

  // const fetchMentorList = async () => {
  //   try {
  //     const response = await fetch("https://ethiccraft.org/backend/Facilitator_Panel/read.php", {
  //       credentials: 'include'
  //     });

  //     if (!response.ok) throw new Error("Failed to fetch mentor list");
  //     const data = await response.json();

  //     // Ensure `data` is an array of objects with at least a `name` or `full_name`
  //     if (Array.isArray(data)) {
  //       setMentorOptions(data);
  //     } else {
  //       throw new Error("Invalid mentor data format");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching mentors:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Mentor List Error",
  //       text: error.message,
  //     });
  //   }
  // };

  const handleWhatsappChange = (e) => {
    const phoneValue = e.target.value;
    const phoneRegex = /^\d{10}$/;
    setWhatsapp(phoneValue);
    setPhoneError(phoneRegex.test(phoneValue) ? "" : "Invalid phone number");
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    setLoading(true); // Start loading

    const requiredFields = [
      { label: "Full Name", value: fullName },
      { label: "Email", value: email },
      { label: "Phone Number", value: whatsapp },
      { label: "Gender", value: gender },
      { label: "Date of Birth", value: dob },
      { label: "Blood Group", value: bloodGroup },
      { label: "Bio", value: bio },
      { label: "College Name", value: collegeName },
      { label: "Department", value: department },
      { label: "Year of Study", value: year },
      { label: "Skills", value: skills },
      { label: "Address", value: address },
      { label: "Social Link", value: socialLink },
      // { label: "Mentor Name", value: mentorName },
    ];

    const emptyField = requiredFields.find(field => {
      return String(field.value || "").trim() === "";
    });

    if (emptyField) {
      setLoading(false);
      Swal.fire({
        icon: 'warning',
        title: 'Missing Field',
        text: `Please fill in the "${emptyField.label}" field before saving.`,
      });
      return;
    }

    const formData = new FormData();

    formData.append("full_name", fullName);
    formData.append("phone_number", whatsapp);
    formData.append("gender", gender);
    formData.append("dob", dob);
    formData.append("blood_group", bloodGroup);
    formData.append("bio", bio);
    formData.append("college", collegeName);
    formData.append("department", department);
    formData.append("year_of_study", year);
    formData.append("skills", skills);
    formData.append("address", address);
    formData.append("social_links", socialLink);
    // formData.append("Mentors_Name", mentorName);
    formData.append("isShown", 1);

    // Validate email and phone before submitting
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;
    let valid = true;

    if (!emailRegex.test(email)) {
      // setEmailError("Invalid email format");
      valid = true;
    } else {
      setEmailError("");
    }

    if (whatsapp && !phoneRegex.test(whatsapp)) {
      setPhoneError("Invalid phone number");
      valid = false;
    } else {
      setPhoneError("");
    }

    if (!valid) {
      setLoading(false); // Stop loading on validation error
      return;
    }

    try {
      const response = await fetch("https://ethiccraft.org/backend/profile/upload.php", {
        method: "POST",
        body: formData,
        credentials: 'include'
      });

      const text = await response.text();
      let json = {};
      try {
        json = JSON.parse(text);
      } catch (e) {
        throw new Error(`Response was not valid JSON: ${text}`);
      }

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: json.message || "Profile updated successfully!",
        }).then((result) => {
          if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
            navigate('/dashboard');
            fetchUserProfile(email); // Refresh profile data after update
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: json.error || "Failed to update profile.",
        });
      }

    } catch (error) {
      console.error("POST ERROR:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.message || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false); // Stop loading after API call
    }
  };

  if (loading) {
    return (
      <div className="profile-edit-container fade-in">
        <div className="loading-indicator">Loading...</div> {/* Simple loading indicator */}
      </div>
    );
  }

  if (fetchError) {
    return (
      <div className="profile-edit-container fade-in">
        <div className="error-message">Error: {fetchError}</div>
      </div>
    );
  }

  return (
    <div className={`profile-edit-container ${fadeIn ? "fade-in" : ""}`}>
      <aside className="profile-sidebar">
        <div className="profile-image-container">
          <img src={image} alt="Profile" className="profile-image" />
        </div>
        <div className="upload-section">
          <input type="file" id="upload" accept="image/*" onChange={handleImageUpload} hidden />
          <label htmlFor="upload" className="upload-image-label">
            Upload Photo
          </label>
        </div>

        <div className="password-change-section">
          <h3>Change Password</h3>
          {/* <div className="password-inputs">
            <label htmlFor="old-password">Old Password</label>
            <input type="password" id="old-password" placeholder="Old Password" />
          </div> */}
          <div className="password-inputs">
            <label htmlFor="new-password">New Password</label>
            <input
              type="password"
              id="new-password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <button className="change-password-button" onClick={handleChangePassword}>
            Change Password
          </button>
          {passwordChanged && <p className="success-message">Password changed successfully!</p>}
        </div>
      </aside>

      <main className="profile-content">
        <form onSubmit={handleSubmit}>
          <section className="profile-information-section">
            <h2>Profile Information</h2>
            <div className="form-grid">
              {/* <div className="form-group">
                <label htmlFor="username">Username</label>
                <input type="text" id="username" value={username} readOnly />
              </div> */}
              <div className="form-group">
                <label htmlFor="full-name">Full Name</label>
                <input type="text" id="full-name" value={fullName} onChange={(e) => setFullName(e.target.value)} />
              </div>
              <div className="form-group">
                <label htmlFor="blood-group">Blood Group</label>
                <input type="text" id="blood-group" value={bloodGroup} onChange={(e) => setBloodGroup(e.target.value)} />
              </div>
              <div className="form-group">
                <label htmlFor="dob">Date Of Birth</label>
                <input type="date" id="dob" value={dob} onChange={(e) => setDoB(e.target.value)} /> {/* Changed input type to 'date' */}
              </div>
              <div className="form-group">
                <label htmlFor="gender">Gender</label>
                <select id="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              {/* <div className="form-group">
                <label htmlFor="Mentors_Name">Mentor Name</label>
                <select id="Mentors_Name" value={mentorName} onChange={(e) => setMentorName(e.target.value)}>
                  <option value="">Select Mentor</option>
                  {mentorOptions.map((mentor, index) => (
                    <option key={index} value={mentor.name || mentor.Full_Name}>
                      {mentor.name || mentor.Full_Name}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </section>

          <section className="contact-information-section">
            <h2>Contact Information</h2>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="email">Email (required)</label>
                <input type="email" id="email" value={email} readOnly required />
                {emailError && <p className="error-message">{emailError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="whatsapp">WhatsApp Number</label>
                <input type="text" id="whatsapp" value={whatsapp} onChange={handleWhatsappChange} />
                {phoneError && <p className="error-message">{phoneError}</p>}
              </div>
              <div className="form-group">
                <label htmlFor="social-link">Instagram (ex, @your_id)</label>
                <input type="text" id="social-link" value={socialLink} onChange={(e) => setSocialLink(e.target.value)} />
              </div>
              <div className="form-group">
                <label htmlFor="address">Address</label>
                <input type="text" id="address" value={address} onChange={(e) => setAddress(e.target.value)} />
              </div>
            </div>
          </section>

          <section className="about-user-section">
            <h2>About the User</h2>
            <div className="form-group">
              <label htmlFor="bio">Biographical Info</label>
              <textarea id="bio" rows="5" value={bio} onChange={(e) => setBio(e.target.value)} />
            </div>
          </section>

          <section className="study-information-section">
            <h2>Study Information</h2>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="college-name">University/College Name</label>
                <input type="text" id="college-name" value={collegeName} onChange={(e) => setCollegeName(e.target.value)} />
              </div>
              <div className="form-group">
                <label htmlFor="department">Department</label>
                <input type="text" id="department" value={department} onChange={(e) => setDepartment(e.target.value)} />
              </div>
              <div className="form-group">
                <label htmlFor="year">Graduation Year</label>
                <input type="text" id="year" value={year} onChange={(e) => setYear(e.target.value)} />
              </div>
              <div className="form-group">
                <label htmlFor="skills">Skills</label>
                <input type="text" id="skills" value={skills} onChange={(e) => setSkills(e.target.value)} />
              </div>
            </div>
          </section>

          <button className="submit-button" type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Save & Continue'}
          </button>
        </form>
      </main>
    </div>
  );
};

export default ProfileEdit;
